import { Form, Select } from 'antd';
import { Rule } from 'antd/lib/form';
import { NamePath } from 'antd/lib/form/interface';
import { ColProps } from 'antd/lib/grid';
import Paragraph from 'components/atoms/Paragraph';
import TranslateText from 'components/hoc/TranslateText';
import InfoTooltip from 'components/molecules/InfoTooltip';
import { isFunction } from 'lodash';
import React, { useCallback } from 'react';

const { Item } = Form;
const { Option } = Select;

export interface ISelectData {
    value: string | number;
    labelcz: string;
    labelen?: string;
}

interface ISelect {
    data: { value: string | number; labelcz: string; labelen?: string }[];
    placeholder?: string;
    defaultValue?: string | string[];
    disabled?: boolean;
    value?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange: (val: any) => void; // TODO: zbavit se any
    mode?: 'multiple' | 'tags';
}

interface ISelectComponent {
    data: { value: string | number; labelcz: string; labelen?: string }[];
    placeholder?: string;
    defaultValue?: string | string[];
    disabled?: boolean;
    name: string;
    labelParagraph?: string;
    value?: string;
    isFormItem?: boolean;
    extramessage?: string;
    dependencies?: NamePath[];
    infoTooltipText?: string;
    validateTrigger?: string;
    rules?: Rule[];
    labelCol?: ColProps;
    mode?: 'multiple' | 'tags';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange?: (val: any) => void; // TODO: zbavit se any
}
const PreSelect: React.FC<ISelect> = ({
    placeholder = 'VYBERTE_PLACEHOLDER',
    data,
    defaultValue,
    disabled,
    onChange,
    mode,
    value
}) => (
    <Select
        placeholder={<TranslateText>{placeholder}</TranslateText>}
        className="input-component"
        style={{
            width: '100%'
        }}
        mode={mode}
        onChange={(e: string | string[]) => onChange(e)}
        defaultValue={defaultValue}
        disabled={disabled}
        value={value}
    >
        {data.map(({ value: selectValue, labelcz }, i) => (
            <Option className="select-option-component" value={selectValue} key={i}>
                <TranslateText>{labelcz}</TranslateText>
            </Option>
        ))}
    </Select>
);

/**
 * SelectComponenta je rozdelena podle labelParagraph, ne vzdycky je potreba mit label a tim padem i Item
 * @param props ISelectComponent
 */
const SelectComponent: React.FC<ISelectComponent> = props => {
    const {
        labelParagraph,
        infoTooltipText = '',
        isFormItem,
        name,
        value,
        placeholder,
        defaultValue,
        extramessage = '',
        data = [],
        dependencies = [],
        validateTrigger,
        rules = [],
        disabled = false,
        onChange,
        mode,
        labelCol
    } = props;

    const updatedValue = useCallback(
        (val: string | [string]) => {
            if (isFunction(onChange)) onChange(val);
        },
        [onChange]
    );

    if (isFormItem)
        return (
            <div>
                <Item
                    label={
                        labelParagraph ? (
                            <>
                                <Paragraph text={labelParagraph} strong={true} />{' '}
                                {infoTooltipText && <InfoTooltip title={infoTooltipText} />}{' '}
                            </>
                        ) : null
                    }
                    labelCol={labelCol}
                    name={name}
                    dependencies={dependencies}
                    rules={rules}
                    validateTrigger={validateTrigger}
                    initialValue={defaultValue} // pri nacitani dat zajisti ze sa setnu aj do form
                    extra={
                        extramessage && (
                            <Paragraph
                                text={extramessage}
                                className="extramessage-text"
                                style={{
                                    display: 'block'
                                }}
                            />
                        )
                    }
                >
                    <PreSelect
                        value={value}
                        mode={mode}
                        data={data}
                        placeholder={placeholder}
                        defaultValue={defaultValue}
                        onChange={updatedValue}
                        disabled={disabled}
                    />
                </Item>
                {extramessage && (
                    <Paragraph
                        text={extramessage}
                        className="extramessage-text"
                        style={{
                            display: 'block'
                        }}
                    />
                )}
            </div>
        );

    return (
        <div>
            <PreSelect
                mode={mode}
                data={data}
                placeholder={placeholder}
                value={value}
                defaultValue={defaultValue}
                onChange={updatedValue}
                disabled={disabled}
            />
        </div>
    );
};

export default SelectComponent;
